// src/libs/utils/getValidRoutes.ts
import { RouteObject } from "react-router-dom";
import { router } from "../../../Router/router/router";

interface RouteMap {
  [moduleTo: string]: Set<string>;
}

// Mapa que se calculará la primera vez que se llame a getValidRoutes
let validRoutesMap: RouteMap | null = null;

const buildValidRoutes = (): RouteMap => {
  const map: RouteMap = {};

  const traverseRoutes = (routes: RouteObject[], parentPath: string = "") => {
    for (const route of routes) {
      const currentPath = route.path
        ? `${parentPath}/${route.path}`.replace(/\/+/g, "/")
        : parentPath;

      const pathSegments = currentPath.split("/").filter(Boolean);

      if (pathSegments.length >= 2) {
        const moduleBase = pathSegments.slice(0, -1).join("/");
        const subRoute = pathSegments[pathSegments.length - 1];

        if (subRoute.startsWith(":") || subRoute === "*") {
          continue;
        }

        if (!map[moduleBase]) {
          map[moduleBase] = new Set();
        }
        map[moduleBase].add(subRoute);
      }

      if (route.children) {
        traverseRoutes(route.children, currentPath);
      }
    }
  };

  traverseRoutes(router.routes);
  return map;
};

export const getValidRoutes = (): RouteMap => {
  // Calcular el mapa la primera vez que se llame
  if (!validRoutesMap) {
    validRoutesMap = buildValidRoutes();
  }
  return validRoutesMap;
};